;(() => {
  'use strict';
  const current = document.currentScript;
  if (!current || !current.src) return;

  function assetUrl(filename) {
    const url = new URL(current.src);
    url.pathname = url.pathname.replace(/led-search-fix\.js$/, filename);
    url.search = 'v=20260908-tier-v3';
    return url.toString();
  }

  function load(filename) {
    const script = document.createElement('script');
    script.src = assetUrl(filename);
    script.async = false;
    document.head.appendChild(script);
  }

  if (window.location.pathname.includes('/apps/tier')) {
    load('tier-b2b-inline-validation.js');
    load('tier-register-page-v3.js');
  } else {
    load('led-search-fix-original.js');
  }
})();